import {Signals} from "@/Imports";
import {calculateRoundMultiplier} from "@/managers/comunication/socket/utils";
import Facade from "@/Facade";

export default class MultiplierManager   {

    constructor () {
        this.multiplier = 0
        Signals.forceRoundStart.add(this.onRoundStart, this)
        Signals.roundEnd.add(this.onRoundEnd, this)
        Signals.stopFeature.add(this.onStopFeature, this)
    }

    onRoundStart() {
        this.interval = setInterval(() => {
            this.multiplier = calculateRoundMultiplier(Facade.model.startTime, Facade.syncTime.time)
            this.multiplier *= Facade.model.bonusMultiplier
            Signals.multiplier.dispatch(this.multiplier)
        }, 100)
    }

    onRoundEnd() {
        clearInterval(this.interval)
    }

    onStopFeature(currentBonus) {
        if(!currentBonus) {
            return
        }
        if(currentBonus.tp == "multiplier") {

            console.log('bonusMultiplier:', Facade.model.bonusMultiplier, 'currentBonus.v:', currentBonus.v)
            Facade.model.bonusMultiplier *= currentBonus.v
        }

        if(currentBonus.tp == "freebet") {
            Facade.model.currentFreebetsValue += currentBonus.v
            console.log('Facade.model.currentFreebetsValue: ', Facade.model.currentFreebetsValue)

            Signals.showfreebets.dispatch(Facade.model.currentFreebetsValue)
        }

    }

}